import { emergencyOrder } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getEmergencyOrderList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(emergencyOrder.emergencyOrderBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getEmergencyOrderObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrder.emergencyOrderBase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getEmergencyOrderFullDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrder.emergencyOrderBase}${id}/details/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  checkEmergencyContract(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrder.emergencyOrderBase}check_emergency_contract/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  resolveCustomerByLane(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrder.emergencyOrderBase}handler_resolve_customer/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  confirmDA(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${emergencyOrder.emergencyOrderBase}${id}/confirm_da/`, data)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  portalCreateDA(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${emergencyOrder.emergencyOrderBase}${id}/portal_create_da/`, data)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  generateDummy(data = {}) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${emergencyOrder.emergencyOrderBase}generate_dummy/`, data)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getLogs(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .get(emergencyOrder.emergencyOrderLogBase, { params: { emergency_order: orderId } })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  previewDestinationRates(id, laneId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrder.emergencyOrderBase}${id}/preview_destination_rates/`, { params: { lane_id: laneId } })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  changeDestination(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${emergencyOrder.emergencyOrderBase}${id}/change_destination/`, data)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  exportToExcel(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrder.emergencyOrderBase}export/`, { params, responseType: "blob" })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
  exportContainersToExcel(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrder.emergencyOrderBase}export-containers/`, { params, responseType: "blob" })
        .then((res) => resolve(res))
        .catch((err) => reject(handleError(err)));
    });
  },
  getInsights(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emergencyOrder.emergencyOrderBase}insights/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
